import API from "customerAttachments/utils/apiUtil"

import "customerAttachments/types"

const customerDomain = "/tw/customer/api"

export const getOrdersList = async ({ page = 1, pageSize = 10 }) => {
  const { data } = await API.get(`${customerDomain}/orders?page=${page}&pageSize=${pageSize}`)
  return data
}

export const getTransfersList = async ({ page = 1, pageSize = 10 }) => {
  const { data } = await API.get(`${customerDomain}/transfers?page=${page}&pageSize=${pageSize}`)
  return data
}

export const getPurchaseOrderAttachmentList = async (orderNo: string | undefined) => {
  if (!orderNo) return
  const { data } = await API.get(`${customerDomain}/orders/${orderNo}/attachments`)
  return data
}

export const getTransferAttachmentList = async (transferId: string | undefined) => {
  if (!transferId) return

  const { data } = await API.get(`${customerDomain}/transfers/${transferId}/attachments`)
  return data
}

// GetPurchaseAttachment
export type getPurchaseOrderAttachmentProps = {
  orderNo: string
  attachType: string
}

export const getPurchaseOrderAttachment = async ({ orderNo, attachType }: getPurchaseOrderAttachmentProps) => {
  const { data } = await API.get(`${customerDomain}/orders/${orderNo}/attachments/${attachType}`)
  return data
}

// UpdatePurchaseAttachment
type updatePurchaseOrderAttachmentProps = {
  orderNo: string
  attachType: string
  payload: any
}

export const updatePurchaseOrderAttachment = async ({
  orderNo,
  attachType,
  payload,
}: updatePurchaseOrderAttachmentProps) => {
  const { data } = await API.put(`${customerDomain}/orders/${orderNo}/attachments/${attachType}/files`, payload)
  return data
}

// getTransferAttachment
export type getTransferOrderAttachmentProps = {
  transferId: string
  attachType: string
}

export const getTransferOrderAttachment = async ({ transferId, attachType }: getTransferOrderAttachmentProps) => {
  const { data } = await API.get(`${customerDomain}/transfers/${transferId}/attachments/${attachType}`)
  return data
}

// UpdateTransferAttachment
type updateTransferOrderAttachmentProps = {
  transferId: string
  attachType: string
  payload: any
}

export const updateTransferOrderAttachment = async ({
  transferId,
  attachType,
  payload,
}: updateTransferOrderAttachmentProps) => {
  const { data } = await API.put(`${customerDomain}/transfers/${transferId}/attachments/${attachType}/files`, payload)
  return data
}
